import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bf-util" }
const _hoisted_2 = { class: "bf-util__card bf-card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("img", {
        src: "/img/brand/bindfy_logo_new_purple.png",
        alt: "Bindfy",
        class: "bf-util__logo"
      }, null, -1)),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "bf-util__code" }, "404", -1)),
      _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "bf-util__title" }, " Ops!! A página que você está procurando não existe! ", -1)),
      _cache[4] || (_cache[4] = _createElementVNode("p", { class: "bf-util__text" }, " A página que você está procurando pode ter sido removida, teve seu nome alterado ou está temporariamente indisponível. ", -1)),
      _createVNode(_component_router_link, {
        class: "bf-btn bf-util__btn",
        to: "/"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("i", { class: "ri-arrow-left-line" }, null, -1),
          _createTextVNode(" Voltar para o Dashboard ", -1)
        ]))]),
        _: 1
      })
    ])
  ]))
}